// keep inactive full gallery images inert until their slide is used.
(() => {
  const hydrate = async (item) => {
    if (!item || item.dataset.galleryHydrating || item.dataset.galleryHydrated) return;
    const template = item.querySelector('.j-gallery-full-template');
    const preview = item.querySelector('.j-gallery-preview');
    const source = template?.content.querySelector('img');
    if (!source || !preview) return;
    item.dataset.galleryHydrating = 'true';
    const full = document.importNode(source, true);
    full.loading = 'eager';
    full.fetchPriority = 'auto';
    try {
      await full.decode();
      if (!full.naturalWidth) throw new Error('decoded image has no intrinsic width');
      preview.replaceWith(full);
      item.dataset.galleryHydrated = 'true';
      delete item.dataset.galleryHydrating;
    } catch (_) {
      delete item.dataset.galleryHydrating;
    }
  };

  const bind = (gallery) => {
    if (gallery.dataset.galleryHydrationBound) return;
    gallery.dataset.galleryHydrationBound = 'true';
    const observer = 'IntersectionObserver' in window ? new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting && entry.intersectionRatio >= 0.55) hydrate(entry.target);
      });
    }, { root: null, threshold: [0.55] }) : null;
    const observeItems = (root) => {
      if (root.matches?.('.product__media-item')) observer?.observe(root);
      root.querySelectorAll?.('.product__media-item').forEach((item) => observer?.observe(item));
    };
    observeItems(gallery);

    gallery.addEventListener('click', (event) => {
      const control = event.target.closest('[data-target]');
      const viewer = gallery.querySelector('.product__media-list');
      if (control && viewer) hydrate(viewer.querySelector(`[data-media-id="${CSS.escape(control.dataset.target)}"]`));
    }, true);
    gallery.addEventListener('pointerdown', (event) => hydrate(event.target.closest('.product__media-item')), true);

    new MutationObserver((records) => records.forEach((record) => {
      if (record.type === 'attributes' && record.target.classList.contains('is-active')) hydrate(record.target);
      record.addedNodes?.forEach((node) => {
        if (node.nodeType !== 1) return;
        observeItems(node);
        if (node.matches?.('.product__media-item.is-active')) hydrate(node);
        node.querySelectorAll?.('.product__media-item.is-active').forEach(hydrate);
      });
    })).observe(gallery, { subtree: true, childList: true, attributes: true, attributeFilter: ['class'] });
  };

  const init = (root = document) => root.querySelectorAll('media-gallery').forEach(bind);
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', () => init()) : init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
